<!--<mat-dialog-content class="rounded-lg">-->
<!--  <div class="flex flex-col place-items-center items-stretch bg-white p-5">-->

<!--    <div class="text-base font-semibold text-base mr-96">Czy na pewno przywrócić z archiwum {{worker.FirstName}} {{worker.LastName}}?</div>-->
<!--  </div>-->
<!--</mat-dialog-content>-->

<!--<div mat-dialog-actions>-->
<!--  <div class="mt-4 flex items-center">-->
<!--    <app-button id="confirm" [isLoading]="isLoading" [isActive]="true" innerTextClasses="text-sm mx-6" spinnerClasses="mx-7 my-1.5"-->
<!--                label="Zarchiwizuj" (click)="onDeactivate()"></app-button>-->

<!--    <sm-button-transparent label="{{'labels.cancel' | translate  | titlecase}}" class="ml-5"-->
<!--                           (click)="onCancel()"></sm-button-transparent>-->
<!--  </div>-->
<!--</div>-->


<div class="!grid place-items-center !h-full">
  <div>
    <div class="flex bg-white p-5 rounded-xl">
      <div class="font-semibold text-base">
        {{'worker.question-move-from-archive' | translate}} {{worker.FirstName}} {{worker.LastName}}?
      </div>
    </div>

    <div class="mt-4 flex items-center">
      <app-button id="confirm" [isLoading]="isLoading" [isActive]="true" innerTextClasses="text-sm mx-6"
                  spinnerClasses="mx-7 my-1.5"
                  label="{{'worker.move-from-archive' | translate}}" (click)="onDeactivate()"></app-button>

      <sm-button-transparent label="{{'labels.cancel' | translate  | titlecase}}" class="ml-5"
                             (click)="onCancel()"></sm-button-transparent>
    </div>
  </div>
</div>
